import { Flex, Heading } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { DefaultContainer } from '@/shared/ui';
import { getWhoIsThisForList } from '../lib/whoIsThisForList';
import FeatureCard from './FeatureCard';

const WhoIsThisForSection = () => {
  const { t } = useTranslation();
  const whoIsThisForList = getWhoIsThisForList(t);

  return (
    <DefaultContainer
      gap='2xl'
      id='who-is-this-for'
      bg='bg.light'
    >
      <Heading textAlign='center'>{t('mainPage.whoIsThisFor.heading')}</Heading>
      <Flex
        flexWrap='wrap'
        gap='xl'
        justifyContent='space-around'
      >
        {whoIsThisForList.map((data) => (
          <FeatureCard
            key={data.heading}
            alignItems='center'
            textAlign='center'
            w={{ base: '80%', sm: '45%', md: '25%' }}
            {...data}
          />
        ))}
      </Flex>
    </DefaultContainer>
  );
};

export default WhoIsThisForSection;
